import Icon from '@material-ui/icons/PictureAsPdf';
import CustomerReceiptsCreate from './CustomerReceiptsCreate';
import CustomerReceiptsList from './CustomerReceiptsList';

export default {
  name: "customerReceipts",
  create: CustomerReceiptsCreate,
  list: CustomerReceiptsList,
  icon: Icon,
};